export class PrimengHelper {
    static primeNgMultiselectClick(event: any): void {
        if (event?.target?.tagName === 'svg' || event?.target?.tagName === 'path') {
            event.stopPropagation();
        }
    }
}
